import { from, of } from 'rxjs'
import { catchError, filter, map, switchMap, tap, delay } from 'rxjs/operators'
import { RootEpic } from '~/Store/types'
import { errorNotification } from '~/Services'
import { RoleService } from '~/Services/RoleServices'
import { OrganizationRoleActions } from './slice'

// Get product claims of role
const getProductClaimsOfRoleEpic: RootEpic = (action$, state$) =>
  action$.pipe(
    filter(OrganizationRoleActions.getProductClaimsOfRole.match),
    switchMap(action => {
      const { clientId, roleId, onSuccess, onFailure } = action.payload

      return from(RoleService.Get.getProducClaimsOfRole(clientId, roleId)).pipe(
        map(res => {
          const claims = (res as any).data
          return OrganizationRoleActions.getProductClaimsOfRoleSuccess(
            claims.productClaims,
          )
        }),
        tap(action => {
          if (onSuccess) onSuccess(action.payload)
        }),
        catchError(error => {
          errorNotification(error)

          const message =
            error?.response?.data?.message ||
            error.message ||
            'Failed to fetch product claims'

          if (onFailure) onFailure(message)

          return of(OrganizationRoleActions.getProductClaimsOfRoleFail(message))
        }),
      )
    }),
  )

// Update product claims of role
const updateProductClaimsEpic: RootEpic = (action$, state$) =>
  action$.pipe(
    filter(OrganizationRoleActions.updateProductClaims.match),
    switchMap(action => {
      const { clientId, roleId, productClaims, onSuccess, onFailure } =
        action.payload

      const data = {
        clientId,
        roleId,
        productClaims,
      }

      return from(RoleService.Put.updateProductClaims(data)).pipe(
        map(() => OrganizationRoleActions.updateProductClaimsSuccess()),
        tap(() => {
          if (onSuccess) onSuccess()
        }),
        catchError(error => {
          errorNotification(error)
          if (onFailure)
            onFailure(error.message || 'Failed to update product claims')
          return of(
            OrganizationRoleActions.updateProductClaimsFail(
              error.message || 'Failed to update product claims',
            ),
          )
        }),
      )
    }),
  )

export const OrganizationRoleEpics = [
  getProductClaimsOfRoleEpic,
  updateProductClaimsEpic,
]
